// Export it as an object so that there is less confusion in the order of the numbers the user will know exactly what
// number is is inputting

export function remove(array: any[], index: number) {
  return array.filter((_, idx) => idx !== index)
}
